import attendanceApi from "@/services/api/attendance";
import { useState } from "react";
import { NpsContext } from "./context";
import { FeedbackProps, NpsDataProps } from "@/interfaces/NpsData";

interface NpsProps {
  children: React.ReactNode; 
}

export function NpsProvider({ children }: NpsProps) {
  const [ npsAtendimentos, setNpsAtendimentos ] = useState<NpsDataProps>();
  const [ feedback, setFeedback ] = useState<FeedbackProps>();
  const [ loading, setLoading ] = useState<boolean>(false);
  
  async function getNpsAtendimentos(params?: object){
    try{
      setLoading(true);
      const response = await attendanceApi.getNpsAtendimentos(params);
      setNpsAtendimentos(response.data) ;
    }catch(error){
      console.error("Erro ao buscar NPS Atendimentos:", error);
      throw error;
    }finally{
      setLoading(false);
    }
  }

  async function getFeedback(atendimento_id: number) {
    try {
      setLoading(true);
      const response = await attendanceApi.getFeedback(atendimento_id);
      setFeedback(response.data);
      return response.data;
    }catch (error) {
      console.error("Erro ao buscar feedback:", error);
      throw error;
    }finally{
      setLoading(false);
    }
  }
  
  return (
    <NpsContext.Provider value={{  
      loading,
      feedback,
      npsAtendimentos,
      getFeedback,
      getNpsAtendimentos
    }}>
      {children}
    </NpsContext.Provider>
  );
}